"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function useWindowMousePosition(x, y) {
    if (x === void 0) {
        x = 0;
    }
    if (y === void 0) {
        y = 0;
    }
    var fpsInterval = 1000 / 30;
    var _React$useState = react_1.default.useState({
        mouseX: x,
        mouseY: y
    }), WindowMousePosition = _React$useState[0], setWindowMousePosition = _React$useState[1];
    react_1.default.useEffect(function () {
        if (typeof window === 'undefined')
            return;
        var requestRunning = null;
        var then = Date.now();
        function handleMouseMove(e) {
            if (requestRunning) {
                window.cancelAnimationFrame(requestRunning);
            }
            requestRunning = window.requestAnimationFrame(function () {
                var now = Date.now();
                var elapsed = now - then;
                if (elapsed > fpsInterval) {
                    then = now - elapsed % fpsInterval;
                    setWindowMousePosition({
                        mouseX: e.clientX,
                        mouseY: e.clientY
                    });
                }
            });
        }
        window.addEventListener("mousemove", handleMouseMove);
        return function () {
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    return WindowMousePosition;
}
exports.default = useWindowMousePosition;
